export default __webpack_public_path__ + "static/media/lock.fceb4b23.svg";